import CryptoJS from "crypto-js";

const MSAL_KEY_HINT = "msal";
let storagePatched = false;
let resolvedSecret = null;

const getFallbackSecretSource = () => {
  if (process.env.REACT_APP_MSAL_CLIENT_ID) {
    return process.env.REACT_APP_MSAL_CLIENT_ID;
  }

  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}-${window.location.pathname}`;
  }

  return "falcon360-msal-secret";
};

const getEncryptionSecret = () => {
  if (resolvedSecret) {
    return resolvedSecret;
  }

  const envSecret = process.env.REACT_APP_MSAL_TOKEN_SECRET;

  if (envSecret && envSecret.trim().length > 0) {
    resolvedSecret = envSecret.trim();
    return resolvedSecret;
  }

  const fallbackSource = getFallbackSecretSource();
  resolvedSecret = CryptoJS.SHA256(`msal-${fallbackSource}`).toString();

  console.warn(
    "MSAL token encryption secret env variable is missing. Falling back to a derived, client-side secret."
  );

  return resolvedSecret;
};

const shouldSecureKey = (key) => {
  const isSecure = typeof key === "string";// && key.toLowerCase().includes(MSAL_KEY_HINT);
  if (isSecure) {
    console.debug(`[MSAL Storage] Securing key: ${key}`);
  }
  return isSecure;
};

export const encryptMsalValue = (value) => {
  if (typeof value !== "string" || value === "") {
    return value;
  }

  try {
    const encrypted = CryptoJS.AES.encrypt(value, getEncryptionSecret()).toString();
    console.debug("[MSAL Storage] Value encrypted successfully.");
    return encrypted;
  } catch (error) {
    console.error("Failed to encrypt MSAL token:", error);
    return value;
  }
};

export const decryptMsalValue = (value) => {
  if (typeof value !== "string" || value === "") {
    return value;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(value, getEncryptionSecret());
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    console.debug("[MSAL Storage] Value decrypted successfully.");
    return decrypted || value;
  } catch (error) {
    return value;
  }
};

export const patchMsalSessionStorage = () => {
  if (storagePatched) {
    return;
  }

  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }

  getEncryptionSecret();

  const storage = window.sessionStorage;
  const originalSetItem = storage.setItem.bind(storage);
  const originalGetItem = storage.getItem.bind(storage);
  const originalRemoveItem = storage.removeItem.bind(storage);

  storage.setItem = (key, value) => {
    if (shouldSecureKey(key) && typeof value === "string") {
      console.debug(`[MSAL Storage] Intercepted setItem for key: ${key}`);
      return originalSetItem(key, encryptMsalValue(value));
    }
    return originalSetItem(key, value);
  };

  storage.getItem = (key) => {
    const value = originalGetItem(key);
    if (!value) {
      return value;
    }

    if (shouldSecureKey(key)) {
      console.debug(`[MSAL Storage] Intercepted getItem for key: ${key}`);
      return decryptMsalValue(value);
    }
    return value;
  };

  storage.removeItem = (key) => {
    if (shouldSecureKey(key)) {
      console.debug(`[MSAL Storage] Removing secured key: ${key}`);
    }
    originalRemoveItem(key);
  };

  Object.keys(storage).forEach((key) => {
    if (shouldSecureKey(key)) {
      const plaintextValue = originalGetItem(key);
      if (plaintextValue && plaintextValue.startsWith("{")) {
        console.debug(`[MSAL Storage] Normalizing existing key: ${key}`);
        const encryptedValue = encryptMsalValue(plaintextValue);
        originalSetItem(key, encryptedValue);
      }
    }
  });

  storagePatched = true;
};

